import axios from "axios";
import { Filter } from "../../components/_WMS/FilterComponent";
import { utcFinalDate, utcIntialDate } from "../../utils/dateHelper";
import { ApiConfig } from "../../config/api";
import { eTypeInventoryCheck } from "../../enums/eInventoryCheck";
import { InventoryCheck, InventoryCheckFilterDto, InventoryCheckUpdateUser, UpdatePriorityDto } from "./entities/InventoryCheck";
import { templateMassiveInventoryCheck} from "../../const/templatesFileName";

export const getInventoryCheck = (
    filters?: Filter[],
    page = 0,
    pageSize = 5,
    orderBy?: { field: string; direction: string }
  ) => {
    const url = new URL(`${ApiConfig.InventoryCheckApi}?typeInventoryCheckId=${eTypeInventoryCheck.Ciclicos}`)
  
    url.searchParams.set('pageIndex', page.toString())
  
    url.searchParams.set('pageSize', pageSize.toString())
  
    if (filters) {
      filters.forEach((element) => {
        if (
          element.key === 'initialPromiseDate' ||
          element.key === 'initialCreatedDate'
        ) {
          url.searchParams.set(element.key, utcIntialDate(element.value))
        } else if (
          element.key === 'finalPromiseDate' ||
          element.key === 'finalCreatedDate'
        ) {
          url.searchParams.set(element.key, utcFinalDate(element.value))
        } else if (element.key === 'tag') {
          //se valida entidad con tag vacio
          if (element.value.toString() === '')
            url.searchParams.set('IncludeWithoutTag', 'true')
          else url.searchParams.set(element.key, element.value.toString())
        } else {
          url.searchParams.append(element.key, element.value.toString())
        }
      })
    }
  
    if (orderBy) {
      url.searchParams.set(
        'sorters',
        JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
      )
    }
  
    return axios.get(url.toString())
  }

  export const getInventoryCheckDetail = (
    inventoryCheckId:number
  ) => {
    const url = new URL(`${ApiConfig.InventoryCheckApi}/${inventoryCheckId}`)

    return axios.get(url.toString())
  }

  export const getInventoryCheckBlog = (
    inventoryCheckId:number
  ) => {
    const url = new URL(`${ApiConfig.InventoryCheckApi}/${inventoryCheckId}/blog`)

    return axios.get(url.toString())
  }


  export const getUserAvailable = (
    inventoryCheckDetailId:number
  ) => {
    const url = new URL(`${ApiConfig.InventoryCheckUserApi}/AvailableUsers/${inventoryCheckDetailId}`)

    return axios.get(url.toString())
  }

  export const updateInventoryCheckDetailUser = (id: number ,dto: InventoryCheckUpdateUser) => {
    const url = new URL(`${ApiConfig.InventoryCheckDetailApi}/${id}/User`)
    return axios.patch(url.toString(), dto)
  }

  export const getInventoryCheckUsers = (
    inventoryCheckId:number
  ) => {
    const url = new URL(`${ApiConfig.InventoryCheckUserApi}/${inventoryCheckId}`)

    return axios.get(url.toString())
  }

  export const getInventoryCheckUsersList = (
    inventoryCheckId?:number
  ) => {

    const url = new URL(`${ApiConfig.InventoryCheckUserApi}/Users`)

    if(inventoryCheckId)
      url.searchParams.append('inventoryCheckId', inventoryCheckId.toString())

    return axios.get(url.toString())
  }

  export const postInventoryCheck = (
    dto:FormData
  ) => {

    const url = new URL(`${ApiConfig.ProcessApi}/InventoryCheckUploadFile`)

    const headers = {
      'Content-Type':'multipart/form-data'
    };

    return axios.post(url.toString(),dto, { headers })
  }

  export const getInventoryCheckTemplate = ()=> {
    const url =  new URL(`${ApiConfig.ProcessApi}/GetTemplateFile/${templateMassiveInventoryCheck}`)
    return axios.get(url.toString());
  }

  export const patchIventoryCheck= (inventoryCheckIds: number[], newTag: string) => {
    const url = new URL(`${ApiConfig.InventoryCheckApi}`)
    return axios.patch(url.toString(), {
      inventoryCheckIds,
      newTag
    })
  }

  export const deleteInventoryCheck = (inventoryCheckId: number) => {
    const url = new URL(`${ApiConfig.InventoryCheckApi}/${inventoryCheckId}`)
    return axios.delete(url.toString())
  }

  export const updateInventoryCheck = (id: number ,dto: InventoryCheck) => {
    const url = new URL(`${ApiConfig.InventoryCheckApi}/${id}`)
    return axios.put(url.toString(), dto)
  }

  export const updatePriority = (
    id: number,
    text: string,
    filters?: Filter[],
    page = 0,
    pageSize = 5,
    orderBy?: { field: string; direction: string }
  ) => {

    let endpoint = '';

    switch (text){
      case 'top':
        endpoint = 'UpdatePriorityTop';
        break
      case 'up':
        endpoint = 'UpdatePriorityUp';
        break
      case 'down':
        endpoint = 'UpdatePriorityDown';
        break
      default:
        throw new Error('Tipo de Acción no es válido')
    }

    const url = new URL(
      `${ApiConfig.InventoryCheckApi}/${id}/${endpoint}`
    )

    const filterDto = buildFilters(filters);
  
    const requestBody: UpdatePriorityDto = {
      filters :filterDto,
      sorters:  orderBy ? [{ dataField: orderBy.field, sortOrder: orderBy.direction }] : undefined, 
      pageIndex: page,
      pageSize: pageSize,
    };


    return axios.put(url.toString(), requestBody)
  }

  const buildFilters = (filters?: Filter[]): InventoryCheckFilterDto => {
    const filterDto: Record<string, unknown> = {};
  
    if(filters){
    filters.forEach((element) => {
      if (element.key === 'initialPromiseDate' || element.key === 'initialCreatedDate') {
        const date = utcIntialDate(element.value);
        filterDto[element.key] = date;
      } else if (element.key === 'finalPromiseDate' || element.key === 'finalCreatedDate') {
        const date = utcFinalDate(element.value);
        filterDto[element.key] = date;
      } else if (element.key === 'tag') {
        //se valida entidad con tag vacio
        if (element.value.toString() === '')
          filterDto.includeWithoutTag= true;
        else 
          filterDto.tag= element.value.toString();
      } else {
        // Asigna otros valores directamente
        filterDto[element.key] = element.value;
      }
    });
    }

    return filterDto as InventoryCheckFilterDto;
  };
